export default __webpack_public_path__ + "static/media/invoice_created.f1b80fcc.png";